import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-configuration-messages-dialog',
    templateUrl: './configuration-messages-dialog.component.html',
    styleUrls: ['./configuration-messages-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton]
})
export class ConfigurationMessagesDialogComponent {
  private dialogRef = inject<MatDialogRef<ConfigurationMessagesDialogComponent>>(MatDialogRef);
  private data = inject(MAT_DIALOG_DATA);


  messages: string[];

  constructor() {
    const data = this.data;

    this.messages = data.messages;
  }

  close(): void {
    this.dialogRef.close(null);
  }

}
